export default function (Vue) {
  let authenticatedUser = {}

  Vue.auth = {
    setToken (token, expiration) {
      localStorage.setItem('token', btoa(token))
      localStorage.setItem('expiration', expiration + Date.now())
    },
    getToken () {
      const token = localStorage.getItem('token')
      const expiration = localStorage.getItem('expiration')

      if (!token || !expiration) {
        return null
      }

      if (Date.now() > parseInt(expiration)) {
        this.destroyToken()
        return null
      } else {
        return atob(token)
      }
    },
    destroyToken () {
      localStorage.removeItem('token')
      localStorage.removeItem('expiration')
    },
    isAuthenticated () {
      return !!(this.getToken())
    },
    setAuthenticatedUser (data) {
      authenticatedUser = data
    },
    getAuthenticatedUser () {
      return authenticatedUser
    },
    decrypt (obj) {
      return JSON.parse(
        atob(obj)
      )
    },
    savePermissions (value) {
      localStorage.setItem('perms', value)
    },
    hasPermissions () {
      return localStorage.getItem('perms') !== null
    },
    getPermissions () {
      return (this.hasPermissions()) ? this.decrypt(localStorage.getItem('perms')) : []
    },
    hasAllPermissions () {
      return this.getPermissions().indexOf('all') > -1
    },
    hasPermission (permissions) {
      return this.hasAllPermissions() || this.getPermissions().some((item) => {
        return item === permissions
      })
    }
  }

  Object.defineProperties(Vue.prototype, {
    $auth: {
      get () {
        return Vue.auth
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/packages/Auth.js